import React, { useEffect, useState } from "react";
import { ApiHelper } from "../../utils/ApiHelper";
import { UPDATE_USER, UPLOAD_COMPANY_LOGO } from "../../lib/API_KEYS";

const EditUserModal = ({ isOpen, onClose, user, onSave }) => {
  const [formData, setFormData] = useState({
    profilePic: null,
    name: "",
    email: "",
    role: "",
    country: "",
    city: "",
    postcode: "",
  });

  useEffect(() => {
    if (isOpen && user) {
      setFormData({
        profilePic: user.profilePic || null,
        name: user.name || "",
        email: user.email || "",
        role: user.role || "",
        country: user.country || "",
        city: user.city || "",
        postcode: user.postcode || "",
      });
    }
  }, [isOpen, user]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, files, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleRemovePhoto = () => {
    setFormData((prev) => ({ ...prev, profilePic: null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let profilePicUrl = "";

      if (formData.profilePic instanceof File) {
        const uploadRes = await new ApiHelper().FetchFromServer(
          ...UPLOAD_COMPANY_LOGO,
          undefined,
          { fileName: formData.profilePic.name, fileType: formData.profilePic.type, fileSize: formData.profilePic.size },
        );

        if (uploadRes.data?.isError || !uploadRes.data?.signedRequest) {
          console.error("Failed to get upload URL");
          return;
        }

        await fetch(uploadRes.data.signedRequest, {
          method: "PUT", body: formData.profilePic, headers: {
            "Content-Type": formData.profilePic.type,
          },
        });
        profilePicUrl = uploadRes.data.fileUrl;
      }
      const updatedUser = { ...formData, profilePic: profilePicUrl || formData.profilePic };
      const response = await new ApiHelper().FetchFromServer(
        UPDATE_USER[0].replace(":userId", user._id),
        UPDATE_USER[1],
        undefined,
        updatedUser
      );
      console.log("updatedUser", updatedUser)

      if (response?.data) {
        onSave({ ...user, ...updatedUser });
        onClose();
      }
    } catch (error) {
      console.error("Update user error:", error);
    }
  };


  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={{ ...styles.modal, ...styles.fadeIn }} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.header}>Edit User</h3>
        <hr />

        <form style={styles.form} onSubmit={handleSubmit}>

          <div style={styles.formRow}>
            <label style={styles.label}>Photo</label>
            <div style={styles.photoBox}>
              <span style={styles.photoText}>150×150px JPEG, PNG Image</span>
              <div
                style={styles.photoContainer}
                onClick={() => document.getElementById("photoInput").click()}
              >
                {formData.profilePic ? (
                  <img
                    src={typeof formData.profilePic === "object"
                      ? URL.createObjectURL(formData.profilePic)
                      : formData.profilePic
                    }
                    alt="profile"
                    style={styles.photoCircle}
                  />
                ) : (
                  <div style={styles.photoCircle}></div>
                )}

                {formData.profilePic && (
                  <span
                    style={styles.removeIcon}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemovePhoto();
                    }}
                  >
                    ×
                  </span>
                )}

                <input
                  id="photoInput"
                  type="file"
                  name="profilePic"
                  accept="image/*"
                  onChange={handleChange}
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>


          <div style={styles.formRow}>
            <label style={styles.label}>Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              style={styles.input}
            />
          </div>


          <div style={styles.formRow}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              name="email"
              placeholder="Enter email address"
              value={formData.email}
              onChange={handleChange}
              style={styles.input}
            />
          </div>


          <div style={styles.formRow}>
            <label style={styles.label}>Role</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              style={styles.input}
            >
              <option value="">Select role</option>
              <option value="Procurement">Procurement</option>
              <option value="Collaborator">Collaborator</option>
              <option value="Technical">Technical</option>
              <option value="Finance">Finance</option>
            </select>
          </div>


          <div style={styles.formRow}>
            <label style={styles.label}>Country</label>
            <select
              name="country"
              value={formData.country}
              onChange={handleChange}
              style={styles.input}
            >
              <option value="">Select country</option>
              <option>India</option>
              <option>USA</option>

            </select>
          </div>


          <div style={styles.formRow}>
            <label style={styles.label}>City</label>
            <input
              type="text"
              name="city"
              placeholder="Enter your city"
              value={formData.city}
              onChange={handleChange}
              style={styles.input}
            />
          </div>


          <div style={styles.formRow}>
            <label style={styles.label}>Postcode</label>
            <input
              type="text"
              name="postcode"
              placeholder="Enter your postcode"
              value={formData.postcode}
              onChange={handleChange}
              style={styles.input}
            />
          </div>


          <div style={styles.actions}>
            <button type="button" onClick={onClose} style={styles.backBtn}>
              Back
            </button>
            <button type="submit" style={styles.inviteBtn}>
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserModal;

const LABEL_WIDTH = "100px";
const styles = {
  overlay: { position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.4)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1300 },
  modal: { background: "#fff", borderRadius: "12px", width: "520px", padding: "24px", boxShadow: "0px 4px 16px rgba(0,0,0,0.15)", opacity: 0, transform: "translateY(-20px)", transition: "opacity 0.3s ease, transform 0.3s ease" },
  fadeIn: { opacity: 1, transform: "translateY(0)" },
  header: { fontSize: "16px", fontWeight: "600", marginBottom: "20px", textAlign: "left" },
  form: { display: "flex", flexDirection: "column", gap: "16px" },
  formRow: { display: "flex", alignItems: "center", gap: "20px" },
  label: { width: LABEL_WIDTH, fontSize: "14px", color: "#333", textAlign: "left" },
  input: { flex: 1, padding: "10px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "14px", outline: "none" },
  photoBox: { flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between" },
  photoContainer: { position: "relative", width: "60px", height: "60px", cursor: "pointer" },
  photoCircle: { width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", background: "#f3f4f6" },
  removeIcon: { position: "absolute", top: "-6px", right: "-6px", fontSize: "14px", cursor: "pointer", color: "#555", background: "#fff", borderRadius: "50%", width: "18px", height: "18px", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 2px rgba(0,0,0,0.3)" },
  photoText: { fontSize: "13px", color: "#666", marginTop: "6px", textAlign: "center" },
  actions: { display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "10px" },
  backBtn: { padding: "8px 16px", border: "1px solid #1a1a40", borderRadius: "8px", background: "#fff", cursor: "pointer", fontSize: "14px" },
  inviteBtn: { padding: "8px 16px", border: "none", borderRadius: "8px", background: "#1a1a40", color: "#fff", cursor: "pointer", fontSize: "14px" },
};
